/**
 * Internal dependencies.
 */
import edit from './edit';
import metadata from './block.json';
import { PostCarouselIcon as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Post Carousel' ),
	description: __( 'Gutenify Post Carousel.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Post Carousel' ),
		__( 'Posts' ),
		__( 'Post' ),
		__( 'Slider' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save: () => {},
	supports: {
		html: false,
		align: [ 'center', 'wide', 'full' ],
	},
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
